var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("loading-page")
        : _vm.error
        ? _c("default-page", {
            attrs: { buttonText: "Reload", errorMessage: _vm.errorMessage },
            on: { "button-clicked": _vm.fetchSettings },
          })
        : _c(
            "div",
            {
              class: _vm.darkTheme
                ? "pageBackground_dark"
                : "pageBackground_light",
            },
            [
              _c("confirm-dialog", {
                attrs: {
                  dialog: _vm.confirmDialog,
                  text: _vm.confirmationDialogText,
                  acceptButton: _vm.deletingUser ? "delete" : "Reset",
                  title: _vm.deletingUser ? "Delete User" : "Reset Settings",
                },
                on: {
                  "confirmation-event": _vm.confirmationEventFunction,
                  "mutate-confirm-dialog": function ($event) {
                    return _vm.confirmationEvent($event)
                  },
                },
              }),
              _c(
                "v-dialog",
                {
                  attrs: {
                    width: "750",
                    transition: "scroll-x-transition",
                    "overlay-color": "grey darken-2",
                    persistent: "",
                  },
                  model: {
                    value: _vm.userDialog,
                    callback: function ($$v) {
                      _vm.userDialog = $$v
                    },
                    expression: "userDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "accent",
                      staticStyle: { "max-width": "750px" },
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticStyle: {
                            "background-color": "#47bd96",
                            color: "white",
                            "letter-spacing": "0.03rem",
                            height: "40px",
                          },
                          style: _vm.$vuetify.breakpoint.xsOnly
                            ? "text-align: center !important;"
                            : "",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.add ? "Add User" : "Edit User") + " "
                          ),
                        ]
                      ),
                      _c(
                        "v-form",
                        {
                          ref: "userForm",
                          staticClass: "pt-8",
                          model: {
                            value: _vm.userFormValid,
                            callback: function ($$v) {
                              _vm.userFormValid = $$v
                            },
                            expression: "userFormValid",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "mx-2" },
                            _vm._l(_vm.userFields, function (field) {
                              return _c(
                                "v-col",
                                {
                                  key: field.text,
                                  staticClass: "py-0",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  field.type === "selector"
                                    ? _c("v-select", {
                                        attrs: {
                                          outlined: "",
                                          dense: "",
                                          multiple: field.value === "roles",
                                          "menu-props": { offsetY: true },
                                          "item-text": "text",
                                          label: field.text,
                                          items:
                                            field.value === "enabled"
                                              ? _vm.enableItems
                                              : _vm.userRoles,
                                          rules:
                                            field.value !== "enabled"
                                              ? [_vm.rules.required]
                                              : [],
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-0" },
                                                    [_vm._v(_vm._s(item.text))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value:
                                            _vm.currentUserEditing[field.value],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentUserEditing,
                                              field.value,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "currentUserEditing[field.value]",
                                        },
                                      })
                                    : _c("v-text-field", {
                                        staticClass:
                                          "textFieldOverride small-icon",
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          disabled:
                                            _vm.edit &&
                                            field.value === "username",
                                          hint:
                                            field.value === "password"
                                              ? _vm.passwordHint
                                              : null,
                                          "persistent-hint": _vm.edit,
                                          label: field.text,
                                          type:
                                            field.value === "password" &&
                                            _vm.showPassword
                                              ? field.value
                                              : "text",
                                          rules:
                                            field.value === "email"
                                              ? [
                                                  _vm.rules.required,
                                                  _vm.rules.email,
                                                ]
                                              : _vm.add
                                              ? [_vm.rules.required]
                                              : [],
                                          "append-icon":
                                            field.value === "password"
                                              ? _vm.showPassword
                                                ? "fas fa-eye-slash"
                                                : "fas fa-eye"
                                              : "",
                                        },
                                        on: {
                                          "click:append": function ($event) {
                                            _vm.showPassword = !_vm.showPassword
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.currentUserEditing[field.value],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentUserEditing,
                                              field.value,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "currentUserEditing[field.value]",
                                        },
                                      }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _vm.newUserViolations.length
                            ? _c("p", { staticClass: "red--text ml-6 mb-2" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.newUserViolations.length === 1
                                        ? "Violation"
                                        : "Violations"
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.newUserViolations.length
                            ? _c(
                                "ul",
                                _vm._l(
                                  _vm.newUserViolations,
                                  function (violation) {
                                    return _c(
                                      "li",
                                      {
                                        key: violation,
                                        staticClass: "red--text mx-6",
                                      },
                                      [_vm._v(" " + _vm._s(violation) + " ")]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        { staticClass: "pt-0" },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.userDialog = !_vm.userDialog
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", text: "" },
                              on: { click: _vm.saveUser },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _vm.$vuetify.breakpoint.smAndUp
                            ? _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "primary more-btn mt-1 mr-1",
                                    attrs: {
                                      rounded: "",
                                      icon: "",
                                      text: "",
                                      dark: "",
                                      width: "28",
                                      height: "28",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.confirmDialog = true
                                      },
                                    },
                                  },
                                  _vm.isNotDesktop ? 0 : on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { "font-size": "16px" },
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("fas fa-redo-alt")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Reset to Default")])]
              ),
              _c(
                "v-tabs",
                {
                  staticClass: "v-tabs-customClass",
                  attrs: {
                    slot: "extension",
                    height: "50",
                    id: "vTabsId",
                    "show-arrows": "",
                    centered: "",
                    "background-color": _vm.$vuetify.theme.dark
                      ? "#262B2E"
                      : "#fff",
                    "center-active": "",
                    "slider-size": 3,
                    "hide-slider": true,
                  },
                  slot: "extension",
                  model: {
                    value: _vm.tabs,
                    callback: function ($$v) {
                      _vm.tabs = $$v
                    },
                    expression: "tabs",
                  },
                },
                [
                  _vm.$vuetify.breakpoint.xsOnly
                    ? _c(
                        "v-tab",
                        {
                          key:
                            _vm.currentTabItem != null
                              ? _vm.currentTabItem.id
                              : 0,
                          staticClass: "vTabClassMobile tabs-border-bottom",
                          staticStyle: {
                            height: "50px",
                            "margin-right": "auto",
                          },
                          attrs: { "active-class": "selectedTab" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.currentTabItem == null
                                ? "No tab"
                                : _vm.currentTabItem.name
                            ) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.$vuetify.breakpoint.xsOnly
                    ? _c(
                        "v-menu",
                        {
                          attrs: {
                            transition: "slide-y-transition",
                            "content-class": "normal-menu",
                            bottom: "",
                            left: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "white--text more-btn",
                                          attrs: { icon: "", text: "" },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icon-more-21x21",
                                            staticStyle: {
                                              "font-size": "28px",
                                              "margin-right": "2px",
                                              "letter-spacing": "0 !important",
                                            },
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "path1 letterSpacing0",
                                            }),
                                            _c("span", {
                                              staticClass:
                                                "path2 letterSpacing0",
                                            }),
                                            _c("span", {
                                              staticClass:
                                                "path3 letterSpacing0",
                                            }),
                                            _c("span", {
                                              staticClass:
                                                "path4 letterSpacing0",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1001484682
                          ),
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.confirmDialog = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        { staticClass: "mr-5" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "20px",
                                              },
                                            },
                                            [_vm._v("fas fa-redo-alt")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticStyle: {
                                                "font-size": "15px",
                                              },
                                            },
                                            [_vm._v("Reset to Default ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list",
                                {
                                  staticStyle: { "margin-top": "1px" },
                                  attrs: { dense: "" },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticClass:
                                        "pl-4 pt-3 pb-2 font-weight-bold normal-bottom-border",
                                      staticStyle: { "font-size": "15px" },
                                    },
                                    [_vm._v("Settings ")]
                                  ),
                                  _vm._l(
                                    _vm.settingsSections,
                                    function (section, index) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: section.name,
                                          on: {
                                            click: function ($event) {
                                              return _vm.addItem(section, index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "mb-1",
                                              class:
                                                _vm.currentTabItem.id ===
                                                section.id
                                                  ? "primary--text-persist"
                                                  : "supplementary-class",
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(section.name) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._l(_vm.settingsSections, function (section, index) {
                        return _c(
                          "v-tab",
                          {
                            key: section.name,
                            staticClass: "vTabClass",
                            attrs: { "active-class": "selectedTab" },
                            on: {
                              click: function ($event) {
                                return _vm.addItem(section, index)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                style:
                                  index === 2 || index === 3
                                    ? "font-size: 18px !important;"
                                    : "opacity:1;",
                                attrs: { medium: "", left: "" },
                              },
                              [_vm._v(_vm._s(section.icon) + " ")]
                            ),
                            _vm._v(" " + _vm._s(section.name) + " "),
                          ],
                          1
                        )
                      }),
                  _vm.isAdmin
                    ? _vm._l(
                        _vm.adminSettingsSections,
                        function (section, index) {
                          return _c(
                            "v-tab",
                            {
                              key: section.name,
                              staticClass: "vTabClass",
                              attrs: { "active-class": "selectedTab" },
                              on: {
                                click: function ($event) {
                                  return _vm.addItem(
                                    section,
                                    index + _vm.settingsSections.length - 1
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  style: "font-size: 18px !important;",
                                  attrs: { medium: "", left: "" },
                                },
                                [_vm._v(_vm._s(section.icon) + " ")]
                              ),
                              _vm._v(" " + _vm._s(section.name) + " "),
                            ],
                            1
                          )
                        }
                      )
                    : _vm._e(),
                  _c(
                    "v-tabs-items",
                    {
                      style: `overflow: hidden auto;height: ${
                        _vm.windowSizeY - 105
                      }px;`,
                      attrs: { touchless: true },
                      model: {
                        value: _vm.currentTabItem.id,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentTabItem, "id", $$v)
                        },
                        expression: "currentTabItem.id",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        {
                          staticClass: "darkText dashboardTabItem",
                          attrs: { disabled: true },
                        },
                        [
                          _vm.isAdmin
                            ? _c("v-row", { attrs: { justify: "center" } }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass: "titleClass",
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    staticStyle: { "padding-top": "30px" },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        class: _vm.darkTheme
                                          ? "title_dark"
                                          : "title_light",
                                        staticStyle: { "font-size": "23px" },
                                        attrs: { left: "" },
                                      },
                                      [_vm._v("far fa-chart-bar ")]
                                    ),
                                    _vm._v(" Dashboard "),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c("v-row", { attrs: { justify: "center" } }, [
                                _c(
                                  "h2",
                                  {
                                    staticClass: "py-5 my-5 secondary-h1",
                                    class: _vm.darkTheme
                                      ? "lightText"
                                      : "darkText2",
                                  },
                                  [_vm._v(" Dashboard Parameters ")]
                                ),
                              ])
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "v-form",
                                {
                                  ref: "dashboardForm",
                                  attrs: {
                                    id: "dashboardForm",
                                    "lazy-validation": false,
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "10",
                                            xl: "3",
                                            lg: "4",
                                            md: "4",
                                            sm: "5",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "settings-number-input",
                                            attrs: {
                                              id: "dashboardurl",
                                              dense: "",
                                              outlined: "",
                                              label:
                                                "URL e.g http://analytics.dealio.ai",
                                              value:
                                                _vm.getFilteredSettings.general
                                                  .dashboard.url,
                                              rules: [_vm.rules.url],
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.ignoreInputChange
                                                  ? ""
                                                  : _vm.updateSetting(
                                                      [
                                                        "general",
                                                        "dashboard",
                                                        "url",
                                                      ],
                                                      "dashboardurl",
                                                      _vm.rules.url
                                                    )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function () {
                                                    return [
                                                      _vm.fieldStatusIs(
                                                        "dashboardurl",
                                                        _vm.getErrorEnums
                                                          .LOADING
                                                      )
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              staticClass:
                                                                "saving-icon mt-1",
                                                              attrs: {
                                                                size: "16",
                                                                width: "2",
                                                                dense: "",
                                                                color:
                                                                  "primary",
                                                                indeterminate:
                                                                  "",
                                                              },
                                                            }
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardurl",
                                                            _vm.getErrorEnums
                                                              .SAVED
                                                          )
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-green mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-check "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardurl",
                                                            _vm.getErrorEnums
                                                              .DEFAULT
                                                          )
                                                        ? _c("div")
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-red mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-times "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              2778281722
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "10",
                                            xl: "3",
                                            lg: "4",
                                            md: "4",
                                            sm: "5",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "settings-number-input",
                                            attrs: {
                                              id: "dashboardsecret_key",
                                              dense: "",
                                              outlined: "",
                                              label: "Secret Key",
                                              value:
                                                _vm.getFilteredSettings.general
                                                  .dashboard.secret_key,
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.ignoreInputChange
                                                  ? ""
                                                  : _vm.updateSetting(
                                                      [
                                                        "general",
                                                        "dashboard",
                                                        "secret_key",
                                                      ],
                                                      "dashboardsecret_key"
                                                    )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function () {
                                                    return [
                                                      _vm.fieldStatusIs(
                                                        "dashboardsecret_key",
                                                        _vm.getErrorEnums
                                                          .LOADING
                                                      )
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              staticClass:
                                                                "saving-icon mt-1",
                                                              attrs: {
                                                                size: "16",
                                                                width: "2",
                                                                dense: "",
                                                                color:
                                                                  "primary",
                                                                indeterminate:
                                                                  "",
                                                              },
                                                            }
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardsecret_key",
                                                            _vm.getErrorEnums
                                                              .DEFAULT
                                                          )
                                                        ? _c("div")
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-green mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-check "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1689864221
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "10",
                                            xl: "3",
                                            lg: "4",
                                            md: "4",
                                            sm: "5",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "settings-number-input",
                                            attrs: {
                                              id: "dashboardexp",
                                              type: "number",
                                              dense: "",
                                              outlined: "",
                                              label:
                                                "Expiration time (in seconds)",
                                              value:
                                                _vm.getFilteredSettings.general
                                                  .dashboard.exp,
                                              rules: [_vm.rules.num],
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.ignoreInputChange
                                                  ? ""
                                                  : _vm.updateSetting(
                                                      [
                                                        "general",
                                                        "dashboard",
                                                        "exp",
                                                      ],
                                                      "dashboardexp",
                                                      _vm.rules.num
                                                    )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function () {
                                                    return [
                                                      _vm.fieldStatusIs(
                                                        "dashboardexp",
                                                        _vm.getErrorEnums
                                                          .LOADING
                                                      )
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              staticClass:
                                                                "saving-icon mt-1",
                                                              attrs: {
                                                                size: "16",
                                                                width: "2",
                                                                dense: "",
                                                                color:
                                                                  "primary",
                                                                indeterminate:
                                                                  "",
                                                              },
                                                            }
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardexp",
                                                            _vm.getErrorEnums
                                                              .SAVED
                                                          )
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-green mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-check "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardexp",
                                                            _vm.getErrorEnums
                                                              .DEFAULT
                                                          )
                                                        ? _c("div")
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-red mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-times "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1046784124
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "10",
                                            xl: "3",
                                            lg: "4",
                                            md: "4",
                                            sm: "5",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "settings-number-input",
                                            attrs: {
                                              id: "dashboardrefresh_time",
                                              type: "number",
                                              dense: "",
                                              outlined: "",
                                              label:
                                                "Auto-refresh time (min 3 sec, default 15 sec)",
                                              value:
                                                _vm.getFilteredSettings.general
                                                  .dashboard.refresh_time,
                                              rules: [_vm.rules.min],
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.ignoreInputChange
                                                  ? ""
                                                  : _vm.updateSetting(
                                                      [
                                                        "general",
                                                        "dashboard",
                                                        "refresh_time",
                                                      ],
                                                      "dashboardrefresh_time",
                                                      _vm.rules.min
                                                    )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function () {
                                                    return [
                                                      _vm.fieldStatusIs(
                                                        "dashboardrefresh_time",
                                                        _vm.getErrorEnums
                                                          .LOADING
                                                      )
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              staticClass:
                                                                "saving-icon mt-1",
                                                              attrs: {
                                                                size: "16",
                                                                width: "2",
                                                                dense: "",
                                                                color:
                                                                  "primary",
                                                                indeterminate:
                                                                  "",
                                                              },
                                                            }
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardrefresh_time",
                                                            _vm.getErrorEnums
                                                              .SAVED
                                                          )
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-green mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-check "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardrefresh_time",
                                                            _vm.getErrorEnums
                                                              .DEFAULT
                                                          )
                                                        ? _c("div")
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-red mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-times "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3853769868
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "10",
                                            xl: "3",
                                            lg: "4",
                                            md: "4",
                                            sm: "5",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "settings-number-input",
                                            attrs: {
                                              id: "dashboardnumber",
                                              type: "number",
                                              dense: "",
                                              outlined: "",
                                              label: "Dashboard Number",
                                              value:
                                                _vm.getFilteredSettings.general
                                                  .dashboard.number,
                                              rules: [_vm.rules.num],
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.ignoreInputChange
                                                  ? ""
                                                  : _vm.updateSetting(
                                                      [
                                                        "general",
                                                        "dashboard",
                                                        "number",
                                                      ],
                                                      "dashboardnumber",
                                                      _vm.rules.num
                                                    )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function () {
                                                    return [
                                                      _vm.fieldStatusIs(
                                                        "dashboardnumber",
                                                        _vm.getErrorEnums
                                                          .LOADING
                                                      )
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              staticClass:
                                                                "saving-icon mt-1",
                                                              attrs: {
                                                                size: "16",
                                                                width: "2",
                                                                dense: "",
                                                                color:
                                                                  "primary",
                                                                indeterminate:
                                                                  "",
                                                              },
                                                            }
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardnumber",
                                                            _vm.getErrorEnums
                                                              .SAVED
                                                          )
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-green mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-check "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm.fieldStatusIs(
                                                            "dashboardnumber",
                                                            _vm.getErrorEnums
                                                              .DEFAULT
                                                          )
                                                        ? _c("div")
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "saving-icon-red mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "fas fa-times "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              2375316370
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("v-col", {
                                        staticClass: "py-0",
                                        attrs: {
                                          cols: "10",
                                          xl: "3",
                                          lg: "4",
                                          md: "4",
                                          sm: "5",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h1",
                              {
                                staticClass: "titleClass",
                                class: _vm.darkTheme
                                  ? "title_dark"
                                  : "title_light",
                                staticStyle: { "padding-top": "30px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    staticStyle: { "font-size": "26px" },
                                    attrs: { left: "" },
                                  },
                                  [_vm._v("volume_up ")]
                                ),
                                _vm._v(" Sounds "),
                              ],
                              1
                            ),
                          ]),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h2",
                              {
                                staticClass: "py-5 my-5 secondary-h1",
                                class: _vm.darkTheme
                                  ? "lightText"
                                  : "darkText2",
                              },
                              [_vm._v(" Customize sounds ")]
                            ),
                          ]),
                          _c(
                            "v-row",
                            { attrs: { justify: "center" } },
                            [
                              _vm.$vuetify.breakpoint.xlAndUp
                                ? _c("v-col", {
                                    attrs: { cols: "2", xl: "2", md: "0" },
                                  })
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pt-0",
                                  attrs: {
                                    xl: "3",
                                    lg: "4",
                                    md: "5",
                                    sm: "8",
                                    cols: "10",
                                  },
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "text-center",
                                      class: _vm.darkTheme
                                        ? "title_dark"
                                        : "title_light",
                                      staticStyle: { "padding-bottom": "20px" },
                                    },
                                    [_vm._v(" Available Sounds ")]
                                  ),
                                  _c("v-data-table", {
                                    staticClass: "accent dealio-table",
                                    staticStyle: {
                                      border: "1px solid #47bd96 !important",
                                    },
                                    attrs: {
                                      "mobile-breakpoint": 0,
                                      id: "soundsTable",
                                      dense: "",
                                      height: "210",
                                      "hide-default-footer": "",
                                      "hide-default-header": "",
                                      headers: [
                                        { text: "Sound" },
                                        { text: "Play/Use" },
                                      ],
                                      items: _vm.mp3Sounds,
                                      "fixed-header": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c("tr", [
                                              _c("td", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "mb-0",
                                                    staticStyle: {
                                                      "font-size": "16px",
                                                      "margin-right": "-70px",
                                                      "margin-left": "70px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "play-sound",
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "icon-play-21x21",
                                                          staticStyle: {
                                                            "font-size": "28px",
                                                          },
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "path1 letterSpacing0",
                                                          }),
                                                          _c("span", {
                                                            staticClass:
                                                              "path2",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "12px",
                                                      },
                                                      attrs: {
                                                        bottom: "",
                                                        right: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "alert-cation",
                                                                      attrs: {
                                                                        icon: "",
                                                                      },
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "use-sound",
                                                                        attrs: {
                                                                          color:
                                                                            "white",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "fas fa-sign-out-alt "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          staticStyle: {
                                                            border:
                                                              "1px solid #47bd96",
                                                          },
                                                          attrs: { dense: "" },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-left pl-4 my-0",
                                                              staticStyle: {
                                                                background:
                                                                  "#47bd96",
                                                                color: "white",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Choose an event "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.getEventNames,
                                                            function (
                                                              eventName
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    key: eventName.original,
                                                                    staticStyle:
                                                                      {
                                                                        "border-top":
                                                                          "1px solid #47bd96",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.useSoundAs(
                                                                            eventName.original,
                                                                            item
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                eventName.filtered
                                                                              ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "header",
                                        fn: function ({ props: { headers } }) {
                                          return [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      background: "#47bd96",
                                                      color: "white",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-center mb-0",
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              headers[0].text
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      background: "#47bd96",
                                                      color: "white",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-center mb-0",
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              headers[1].text
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm.$vuetify.breakpoint.mdAndUp
                                ? _c("v-col", { attrs: { cols: "1" } })
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pt-0",
                                  attrs: {
                                    xl: "3",
                                    lg: "4",
                                    md: "5",
                                    sm: "8",
                                    cols: "10",
                                  },
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "text-center",
                                      class: _vm.darkTheme
                                        ? "title_dark"
                                        : "title_light",
                                      staticStyle: { "padding-bottom": "20px" },
                                    },
                                    [_vm._v(" Available Events ")]
                                  ),
                                  _c("v-data-table", {
                                    staticClass: "accent dealio-table",
                                    staticStyle: {
                                      border: "1px solid #47bd96 !important",
                                    },
                                    attrs: {
                                      "mobile-breakpoint": 0,
                                      id: "eventsTable",
                                      dense: "",
                                      height: "210",
                                      "hide-default-footer": "",
                                      "hide-default-header": "",
                                      headers: [
                                        { text: "Event", value: "event" },
                                        { text: "Sound", value: "sound" },
                                      ],
                                      items: _vm.getAvailableEvents,
                                      "fixed-header": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: { height: "37px" },
                                              },
                                              [
                                                _c("td", [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "mb-0",
                                                      class: _vm.$vuetify
                                                        .breakpoint.xsOnly
                                                        ? "eventItemsXS"
                                                        : "eventItems",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.event) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "mb-0",
                                                      class: _vm.$vuetify
                                                        .breakpoint.xsOnly
                                                        ? "soundItemsXS"
                                                        : "soundItems",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.sound) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "header",
                                        fn: function ({ props: { headers } }) {
                                          return [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      background: "#47bd96",
                                                      color: "white",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-center mb-0",
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              headers[0].text
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "th",
                                                  {
                                                    staticStyle: {
                                                      background: "#47bd96",
                                                      color: "white",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-center mb-0",
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              headers[1].text
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm.$vuetify.breakpoint.xlAndUp
                                ? _c("v-col", { attrs: { cols: "2", xl: "2" } })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h1",
                              {
                                staticClass: "titleClass",
                                class: _vm.darkTheme
                                  ? "title_dark"
                                  : "title_light",
                                staticStyle: { "padding-top": "30px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    staticStyle: { "font-size": "20px" },
                                    attrs: { left: "" },
                                  },
                                  [_vm._v("fas fa-paint-brush ")]
                                ),
                                _vm._v(" Appearance "),
                              ],
                              1
                            ),
                          ]),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h2",
                              {
                                staticClass: "py-5 my-5 secondary-h1",
                                class: _vm.darkTheme
                                  ? "lightText"
                                  : "darkText2",
                              },
                              [_vm._v(" Display Mode ")]
                            ),
                          ]),
                          _c(
                            "v-row",
                            { attrs: { justify: "center" } },
                            [_c("mode-picker")],
                            1
                          ),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h1",
                              {
                                staticClass: "titleClass",
                                class: _vm.darkTheme
                                  ? "title_dark"
                                  : "title_light",
                                staticStyle: { "padding-top": "50px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    staticStyle: { "font-size": "19px" },
                                    attrs: { left: "" },
                                  },
                                  [_vm._v("icon-new-notification-24x24 ")]
                                ),
                                _vm._v(" Notifications "),
                              ],
                              1
                            ),
                          ]),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h2",
                              {
                                staticClass: "mt-10 mb-5 secondary-h1",
                                class: _vm.darkTheme
                                  ? "lightText"
                                  : "darkText2",
                              },
                              [_vm._v(" Device notifications ")]
                            ),
                          ]),
                          _c(
                            "v-row",
                            {
                              staticClass: "my-2",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "settings-switch-row pt-2",
                                  staticStyle: {
                                    "border-top":
                                      "1px solid rgb(255, 255, 255, 0.2)",
                                  },
                                  attrs: { justify: "space-between" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "ml-4 mb-0",
                                      class: _vm.darkTheme
                                        ? "lightText"
                                        : "darkText2",
                                    },
                                    [_vm._v(" Enable ")]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticStyle: { "max-width": "88px" } },
                                    [
                                      _c("hr", { attrs: { width: "1" } }),
                                      _c("v-switch", {
                                        staticClass: "mt-0 pl-1 pt-0",
                                        staticStyle: { height: "30px" },
                                        attrs: { id: "enableNotifications" },
                                        model: {
                                          value: _vm.enableNotifications,
                                          callback: function ($$v) {
                                            _vm.enableNotifications = $$v
                                          },
                                          expression: "enableNotifications",
                                        },
                                      }),
                                      _vm.fieldStatusIs(
                                        "enableNotifications",
                                        _vm.getErrorEnums.LOADING
                                      )
                                        ? _c("v-progress-circular", {
                                            staticClass: "saving-icon mt-1",
                                            attrs: {
                                              size: "16",
                                              width: "2",
                                              dense: "",
                                              color: "primary",
                                              indeterminate: "",
                                            },
                                          })
                                        : _vm.fieldStatusIs(
                                            "enableNotifications",
                                            _vm.getErrorEnums.SAVED
                                          )
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-green",
                                            },
                                            [_vm._v("fas fa-check ")]
                                          )
                                        : _vm.fieldStatusIs(
                                            "enableNotifications",
                                            _vm.getErrorEnums.DEFAULT
                                          )
                                        ? _c("div", {
                                            staticStyle: { width: "16px" },
                                          })
                                        : _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-red",
                                              staticStyle: { height: "23px" },
                                            },
                                            [_vm._v("fas fa-times ")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "my-2",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "settings-switch-row",
                                  attrs: {
                                    id: "overwrite-notifications",
                                    justify: "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ml-4 mb-0",
                                      class: _vm.darkTheme
                                        ? "lightText"
                                        : "darkText2",
                                    },
                                    [
                                      _vm._v(
                                        " Update same type notifications "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: _vm.darkTheme
                                            ? "lightText"
                                            : "darkText2",
                                          staticStyle: {
                                            float: "right",
                                            "margin-top": "5px",
                                            "margin-left": "5px",
                                            "font-size": "11px",
                                          },
                                        },
                                        [_vm._v(" (Mobile) ")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticStyle: { "max-width": "88px" } },
                                    [
                                      _c("hr", { attrs: { width: "1" } }),
                                      _c("v-switch", {
                                        staticClass: "mt-0 pl-1 pt-0",
                                        staticStyle: { height: "30px" },
                                        attrs: {
                                          id: "updateSameTypeNotifications",
                                        },
                                        model: {
                                          value:
                                            _vm.updateSameTypeNotifications,
                                          callback: function ($$v) {
                                            _vm.updateSameTypeNotifications =
                                              $$v
                                          },
                                          expression:
                                            "updateSameTypeNotifications",
                                        },
                                      }),
                                      _vm.fieldStatusIs(
                                        "updateSameTypeNotifications",
                                        _vm.getErrorEnums.LOADING
                                      )
                                        ? _c("v-progress-circular", {
                                            staticClass: "saving-icon mt-1",
                                            attrs: {
                                              size: "16",
                                              width: "2",
                                              dense: "",
                                              color: "primary",
                                              indeterminate: "",
                                            },
                                          })
                                        : _vm.fieldStatusIs(
                                            "updateSameTypeNotifications",
                                            _vm.getErrorEnums.SAVED
                                          )
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-green",
                                            },
                                            [_vm._v("fas fa-check ")]
                                          )
                                        : _vm.fieldStatusIs(
                                            "updateSameTypeNotifications",
                                            _vm.getErrorEnums.DEFAULT
                                          )
                                        ? _c("div", {
                                            staticStyle: { width: "16px" },
                                          })
                                        : _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-red",
                                              staticStyle: { height: "23px" },
                                            },
                                            [_vm._v("fas fa-times ")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  staticClass: "mt-3 ml-1",
                                  attrs: {
                                    activator: "#overwrite-notifications",
                                    disabled: _vm.isNotDesktop,
                                    "content-class": "tooltipClassBottom",
                                    bottom: "",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "When enabled, notifications of the same type will overwrite each other."
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "E.g if you receive a Price Guard event twice, the first notification will be"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "overwritten by the second one and you will only see the second notification. "
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "my-2",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "settings-switch-row",
                                  attrs: {
                                    id: "renotify",
                                    justify: "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ml-4 mb-0",
                                      class: {
                                        lightText: _vm.darkTheme,
                                        darkText2: !_vm.darkTheme,
                                        "grey--text":
                                          !_vm.updateSameTypeNotifications,
                                      },
                                    },
                                    [
                                      _vm._v(" Re-notify "),
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            lightText: _vm.darkTheme,
                                            darkText2: !_vm.darkTheme,
                                            "grey--text":
                                              !_vm.updateSameTypeNotifications,
                                          },
                                          staticStyle: {
                                            float: "right",
                                            "margin-top": "5px",
                                            "margin-left": "5px",
                                            "font-size": "11px",
                                          },
                                        },
                                        [_vm._v(" (Mobile) ")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticStyle: { "max-width": "88px" } },
                                    [
                                      _c("hr", { attrs: { width: "1" } }),
                                      _c("v-switch", {
                                        staticClass: "mt-0 pl-1 pt-0",
                                        staticStyle: { height: "30px" },
                                        attrs: {
                                          id: "renotify",
                                          disabled:
                                            !_vm.updateSameTypeNotifications,
                                        },
                                        model: {
                                          value: _vm.renotify,
                                          callback: function ($$v) {
                                            _vm.renotify = $$v
                                          },
                                          expression: "renotify",
                                        },
                                      }),
                                      _vm.fieldStatusIs(
                                        "renotify",
                                        _vm.getErrorEnums.LOADING
                                      )
                                        ? _c("v-progress-circular", {
                                            staticClass: "saving-icon mt-1",
                                            attrs: {
                                              size: "16",
                                              width: "2",
                                              dense: "",
                                              color: "primary",
                                              indeterminate: "",
                                            },
                                          })
                                        : _vm.fieldStatusIs(
                                            "renotify",
                                            _vm.getErrorEnums.SAVED
                                          )
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-green",
                                            },
                                            [_vm._v("fas fa-check ")]
                                          )
                                        : _vm.fieldStatusIs(
                                            "renotify",
                                            _vm.getErrorEnums.DEFAULT
                                          )
                                        ? _c("div", {
                                            staticStyle: { width: "16px" },
                                          })
                                        : _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-red",
                                              staticStyle: { height: "23px" },
                                            },
                                            [_vm._v("fas fa-times ")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  staticClass: "mt-3 ml-1",
                                  attrs: {
                                    activator: "#renotify",
                                    disabled: _vm.isNotDesktop,
                                    "content-class": "tooltipClassBottom",
                                    bottom: "",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "When enabled, overwritten notifications will play a sound."
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h2",
                              {
                                staticClass: "mt-10 mb-5 secondary-h1",
                                class: _vm.darkTheme
                                  ? "lightText"
                                  : "darkText2",
                              },
                              [_vm._v(" In-app notifications ")]
                            ),
                          ]),
                          _c(
                            "v-row",
                            {
                              staticClass: "my-2",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "settings-switch-row pt-2",
                                  staticStyle: {
                                    "border-top":
                                      "1px solid rgb(255, 255, 255, 0.2)",
                                  },
                                  attrs: { justify: "space-between" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "ml-4 mb-0",
                                      class: _vm.darkTheme
                                        ? "lightText"
                                        : "darkText2",
                                    },
                                    [_vm._v(" Stack notifications ")]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticStyle: { "max-width": "88px" } },
                                    [
                                      _c("hr", { attrs: { width: "1" } }),
                                      _c("v-switch", {
                                        staticClass: "mt-0 pl-1 pt-0",
                                        staticStyle: { height: "30px" },
                                        attrs: { id: "stackNotifications" },
                                        model: {
                                          value: _vm.stackNotifications,
                                          callback: function ($$v) {
                                            _vm.stackNotifications = $$v
                                          },
                                          expression: "stackNotifications",
                                        },
                                      }),
                                      _vm.fieldStatusIs(
                                        "stackNotifications",
                                        _vm.getErrorEnums.LOADING
                                      )
                                        ? _c("v-progress-circular", {
                                            staticClass: "saving-icon mt-1",
                                            attrs: {
                                              size: "16",
                                              width: "2",
                                              dense: "",
                                              color: "primary",
                                              indeterminate: "",
                                            },
                                          })
                                        : _vm.fieldStatusIs(
                                            "stackNotifications",
                                            _vm.getErrorEnums.SAVED
                                          )
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-green",
                                            },
                                            [_vm._v("fas fa-check ")]
                                          )
                                        : _vm.fieldStatusIs(
                                            "stackNotifications",
                                            _vm.getErrorEnums.DEFAULT
                                          )
                                        ? _c("div", {
                                            staticStyle: { width: "16px" },
                                          })
                                        : _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-red",
                                              staticStyle: { height: "23px" },
                                            },
                                            [_vm._v("fas fa-times ")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "h3",
                            {
                              staticClass: "text-center settings-text mt-10",
                              staticStyle: { "font-weight": "500" },
                            },
                            [
                              _vm._v(" Device notifications to show: "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://dealio.ai/docs/en/ui/ui-structure-and-features/#alerts--notifications",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "far fa-question-circle",
                                    staticStyle: { "font-size": "17px" },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "v-row",
                            {
                              class: {
                                "notif-show": _vm.$vuetify.breakpoint.lg,
                              },
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  class: {
                                    "py-0": _vm.$vuetify.breakpoint.xsOnly,
                                  },
                                  attrs: {
                                    cols: "12",
                                    xl: "1",
                                    md: "2",
                                    sm: "3",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      class: {
                                        "ml-1": _vm.$vuetify.breakpoint.xsOnly,
                                      },
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "checkbox-md",
                                        style: {
                                          "width: 93px;":
                                            _vm.$vuetify.breakpoint.xsOnly,
                                        },
                                        attrs: {
                                          id: "notificationssuccess",
                                          "off-icon": "far fa-check-circle",
                                          "on-icon": "fas fa-check-circle",
                                          label: "Success",
                                        },
                                        model: {
                                          value: _vm.notificationssuccess,
                                          callback: function ($$v) {
                                            _vm.notificationssuccess = $$v
                                          },
                                          expression: "notificationssuccess",
                                        },
                                      }),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-4",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _vm.fieldStatusIs(
                                            "notificationssuccess",
                                            _vm.getErrorEnums.LOADING
                                          )
                                            ? _c("v-progress-circular", {
                                                staticClass: "saving-icon mt-1",
                                                attrs: {
                                                  size: "16",
                                                  width: "2",
                                                  dense: "",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              })
                                            : _vm.fieldStatusIs(
                                                "notificationssuccess",
                                                _vm.getErrorEnums.SAVED
                                              )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-green mt-1",
                                                },
                                                [_vm._v("fas fa-check ")]
                                              )
                                            : _vm.fieldStatusIs(
                                                "notificationssuccess",
                                                _vm.getErrorEnums.DEFAULT
                                              )
                                            ? _c("div")
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-red mt-1",
                                                },
                                                [_vm._v("fas fa-times ")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  class: {
                                    "py-0": _vm.$vuetify.breakpoint.xsOnly,
                                  },
                                  attrs: {
                                    cols: "12",
                                    xl: "1",
                                    md: "2",
                                    sm: "3",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      class: {
                                        "ml-1": _vm.$vuetify.breakpoint.xsOnly,
                                      },
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "checkbox-md",
                                        style: {
                                          "width: 93px;":
                                            _vm.$vuetify.breakpoint.xsOnly,
                                        },
                                        attrs: {
                                          id: "notificationsinfo",
                                          "off-icon": "far fa-check-circle",
                                          "on-icon": "fas fa-check-circle",
                                          label: "Info",
                                        },
                                        model: {
                                          value: _vm.notificationsinfo,
                                          callback: function ($$v) {
                                            _vm.notificationsinfo = $$v
                                          },
                                          expression: "notificationsinfo",
                                        },
                                      }),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-4",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _vm.fieldStatusIs(
                                            "notificationsinfo",
                                            _vm.getErrorEnums.LOADING
                                          )
                                            ? _c("v-progress-circular", {
                                                staticClass: "saving-icon mt-1",
                                                attrs: {
                                                  size: "16",
                                                  width: "2",
                                                  dense: "",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              })
                                            : _vm.fieldStatusIs(
                                                "notificationsinfo",
                                                _vm.getErrorEnums.SAVED
                                              )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-green mt-1",
                                                },
                                                [_vm._v("fas fa-check ")]
                                              )
                                            : _vm.fieldStatusIs(
                                                "notificationsinfo",
                                                _vm.getErrorEnums.DEFAULT
                                              )
                                            ? _c("div")
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-red mt-1",
                                                },
                                                [_vm._v("fas fa-times ")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  class: {
                                    "py-0": _vm.$vuetify.breakpoint.xsOnly,
                                  },
                                  attrs: {
                                    cols: "12",
                                    xl: "1",
                                    md: "2",
                                    sm: "3",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      class: {
                                        "ml-1": _vm.$vuetify.breakpoint.xsOnly,
                                      },
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "checkbox-md",
                                        attrs: {
                                          id: "notificationserror",
                                          "off-icon": "far fa-check-circle",
                                          "on-icon": "fas fa-check-circle",
                                          label: "Error",
                                        },
                                        model: {
                                          value: _vm.notificationserror,
                                          callback: function ($$v) {
                                            _vm.notificationserror = $$v
                                          },
                                          expression: "notificationserror",
                                        },
                                      }),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-4",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _vm.fieldStatusIs(
                                            "notificationserror",
                                            _vm.getErrorEnums.LOADING
                                          )
                                            ? _c("v-progress-circular", {
                                                staticClass: "saving-icon mt-1",
                                                attrs: {
                                                  size: "16",
                                                  width: "2",
                                                  dense: "",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              })
                                            : _vm.fieldStatusIs(
                                                "notificationserror",
                                                _vm.getErrorEnums.SAVED
                                              )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-green mt-1",
                                                },
                                                [_vm._v("fas fa-check ")]
                                              )
                                            : _vm.fieldStatusIs(
                                                "notificationserror",
                                                _vm.getErrorEnums.DEFAULT
                                              )
                                            ? _c("div")
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-red mt-1",
                                                },
                                                [_vm._v("fas fa-times ")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  class: {
                                    "py-0": _vm.$vuetify.breakpoint.xsOnly,
                                  },
                                  attrs: {
                                    cols: "12",
                                    xl: "1",
                                    md: "2",
                                    sm: "3",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      class: {
                                        "ml-1": _vm.$vuetify.breakpoint.xsOnly,
                                      },
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "checkbox-md",
                                        style: {
                                          "width: 93px !important;":
                                            _vm.$vuetify.breakpoint.xsOnly,
                                        },
                                        attrs: {
                                          id: "notificationswarning",
                                          "off-icon": "far fa-check-circle",
                                          "on-icon": "fas fa-check-circle",
                                          label: "Warning",
                                        },
                                        model: {
                                          value: _vm.notificationswarning,
                                          callback: function ($$v) {
                                            _vm.notificationswarning = $$v
                                          },
                                          expression: "notificationswarning",
                                        },
                                      }),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-4",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _vm.fieldStatusIs(
                                            "notificationswarning",
                                            _vm.getErrorEnums.LOADING
                                          )
                                            ? _c("v-progress-circular", {
                                                staticClass: "saving-icon mt-1",
                                                attrs: {
                                                  size: "16",
                                                  width: "2",
                                                  dense: "",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              })
                                            : _vm.fieldStatusIs(
                                                "notificationswarning",
                                                _vm.getErrorEnums.SAVED
                                              )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-green mt-1",
                                                },
                                                [_vm._v("fas fa-check ")]
                                              )
                                            : _vm.fieldStatusIs(
                                                "notificationswarning",
                                                _vm.getErrorEnums.DEFAULT
                                              )
                                            ? _c("div")
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-red mt-1",
                                                },
                                                [_vm._v("fas fa-times ")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isAdmin
                            ? _c("v-row", { attrs: { justify: "center" } }, [
                                _c(
                                  "h1",
                                  {
                                    staticClass: "titleClass",
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    staticStyle: { "padding-top": "30px" },
                                  },
                                  [_vm._v(" Other ")]
                                ),
                              ])
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c("v-row", { attrs: { justify: "center" } }, [
                                _c(
                                  "h2",
                                  {
                                    staticClass: "py-5 my-5 secondary-h1",
                                    class: _vm.darkTheme
                                      ? "lightText"
                                      : "darkText2",
                                  },
                                  [_vm._v(" Server Sent Events ")]
                                ),
                              ])
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-0",
                                      attrs: {
                                        cols: "10",
                                        xl: "3",
                                        lg: "4",
                                        md: "4",
                                        sm: "5",
                                      },
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "settings-number-input",
                                        attrs: {
                                          id: "ssepingAbsenceLimit",
                                          type: "number",
                                          dense: "",
                                          outlined: "",
                                          label: "Ping absence limit (ms)",
                                          value:
                                            _vm.getFilteredSettings.general.sse
                                              .pingAbsenceLimit,
                                          rules: [_vm.rules.num],
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.ignoreInputChange
                                              ? ""
                                              : _vm.updateSetting(
                                                  [
                                                    "general",
                                                    "sse",
                                                    "pingAbsenceLimit",
                                                  ],
                                                  "ssepingAbsenceLimit",
                                                  _vm.rules.num
                                                )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _vm.fieldStatusIs(
                                                    "ssepingAbsenceLimit",
                                                    _vm.getErrorEnums.LOADING
                                                  )
                                                    ? _c(
                                                        "v-progress-circular",
                                                        {
                                                          staticClass:
                                                            "saving-icon mt-1",
                                                          attrs: {
                                                            size: "16",
                                                            width: "2",
                                                            dense: "",
                                                            color: "primary",
                                                            indeterminate: "",
                                                          },
                                                        }
                                                      )
                                                    : _vm.fieldStatusIs(
                                                        "ssepingAbsenceLimit",
                                                        _vm.getErrorEnums.SAVED
                                                      )
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "saving-icon-green mt-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "fas fa-check "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm.fieldStatusIs(
                                                        "ssepingAbsenceLimit",
                                                        _vm.getErrorEnums
                                                          .DEFAULT
                                                      )
                                                    ? _c("div")
                                                    : _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "saving-icon-red mt-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "fas fa-times "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3967346914
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "v-row",
                                {
                                  staticClass: "pb-5 mb-5 mt-2",
                                  attrs: { justify: "center" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "settings-switch-row pt-2",
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgb(255, 255, 255, 0.2)",
                                      },
                                      attrs: { justify: "space-between" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "ml-4 mb-0",
                                          class: _vm.darkTheme
                                            ? "lightText"
                                            : "darkText2",
                                        },
                                        [_vm._v(" SSE State Logging ")]
                                      ),
                                      _c(
                                        "v-row",
                                        {
                                          staticStyle: { "max-width": "88px" },
                                        },
                                        [
                                          _c("hr", { attrs: { width: "1" } }),
                                          _c("v-switch", {
                                            staticClass: "mt-0 pl-1 pt-0",
                                            staticStyle: { height: "30px" },
                                            attrs: { id: "logSSEState" },
                                            model: {
                                              value: _vm.logSSEState,
                                              callback: function ($$v) {
                                                _vm.logSSEState = $$v
                                              },
                                              expression: "logSSEState",
                                            },
                                          }),
                                          _vm.fieldStatusIs(
                                            "logSSEState",
                                            _vm.getErrorEnums.LOADING
                                          )
                                            ? _c("v-progress-circular", {
                                                staticClass: "saving-icon mt-1",
                                                attrs: {
                                                  size: "16",
                                                  width: "2",
                                                  dense: "",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              })
                                            : _vm.fieldStatusIs(
                                                "logSSEState",
                                                _vm.getErrorEnums.SAVED
                                              )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-green",
                                                },
                                                [_vm._v("fas fa-check ")]
                                              )
                                            : _vm.fieldStatusIs(
                                                "logSSEState",
                                                _vm.getErrorEnums.DEFAULT
                                              )
                                            ? _c("div", {
                                                staticStyle: { width: "16px" },
                                              })
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-red",
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [_vm._v("fas fa-times ")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        { staticClass: "darkText" },
                        [
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h1",
                              {
                                staticClass: "titleClass",
                                class: _vm.darkTheme
                                  ? "title_dark"
                                  : "title_light",
                                staticStyle: { "padding-top": "30px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    attrs: { left: "" },
                                  },
                                  [_vm._v("icon-price-guard-21x25 ")]
                                ),
                                _vm._v(" Price Guard "),
                              ],
                              1
                            ),
                          ]),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h2",
                              {
                                staticClass: "pt-5 mt-5 secondary-h1",
                                class: _vm.darkTheme
                                  ? "lightText"
                                  : "darkText2",
                              },
                              [_vm._v(" Status & Timing ")]
                            ),
                          ]),
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-5 mt-5",
                              attrs: { justify: "center", id: "text-fields" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "10",
                                    xl: "3",
                                    lg: "4",
                                    md: "4",
                                    sm: "5",
                                  },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass:
                                      "rm-number-arrows settings-number-input",
                                    attrs: {
                                      dense: "",
                                      id: "priceguardpriceOldAfter",
                                      type: "number",
                                      outlined: "",
                                      label: "Price aging time (old):",
                                      value:
                                        _vm.getFilteredSettings.applications
                                          .priceguard.priceOldAfter,
                                      height: "20",
                                      rules: [_vm.rules.num],
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.ignoreInputChange
                                          ? ""
                                          : _vm.updateSetting(
                                              [
                                                "applications",
                                                "priceguard",
                                                "priceOldAfter",
                                              ],
                                              "priceguardpriceOldAfter",
                                              _vm.rules.num
                                            )
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "py-0 mr-3",
                                                    staticStyle: {
                                                      "max-width": "24px",
                                                    },
                                                    attrs: { cols: "6" },
                                                  },
                                                  [
                                                    _vm.fieldStatusIs(
                                                      "priceguardpriceOldAfter",
                                                      _vm.getErrorEnums.LOADING
                                                    )
                                                      ? _c(
                                                          "v-progress-circular",
                                                          {
                                                            staticClass:
                                                              "saving-icon mt-1",
                                                            attrs: {
                                                              size: "16",
                                                              width: "2",
                                                              dense: "",
                                                              color: "primary",
                                                              indeterminate: "",
                                                            },
                                                          }
                                                        )
                                                      : _vm.fieldStatusIs(
                                                          "priceguardpriceOldAfter",
                                                          _vm.getErrorEnums
                                                            .SAVED
                                                        )
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "saving-icon-green mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "fas fa-check "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.fieldStatusIs(
                                                          "priceguardpriceOldAfter",
                                                          _vm.getErrorEnums
                                                            .DEFAULT
                                                        )
                                                      ? _c("div")
                                                      : _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "saving-icon-red mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "fas fa-times "
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "py-0 mr-1",
                                                    attrs: { cols: "4" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          justify: "start",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              "max-width":
                                                                "300",
                                                              bottom: "",
                                                              "content-class":
                                                                "text-center",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-icon",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "pt-1",
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            "far fa-question-circle "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ]
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Time in seconds (from when a price matched the rule) after which it is considered old. Default: 30sec "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "10",
                                    xl: "3",
                                    lg: "4",
                                    md: "4",
                                    sm: "5",
                                  },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass:
                                      "text-field rm-number-arrows settings-number-input",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      label: "Price expiration time:",
                                      id: "priceguarddataExpirationCycle",
                                      type: "number",
                                      value:
                                        _vm.getFilteredSettings.applications
                                          .priceguard.dataExpirationCycle,
                                      height: "20",
                                      color: "primary",
                                      rules: [_vm.rules.num],
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.ignoreInputChange
                                          ? ""
                                          : _vm.updateSetting(
                                              [
                                                "applications",
                                                "priceguard",
                                                "dataExpirationCycle",
                                              ],
                                              "priceguarddataExpirationCycle",
                                              _vm.rules.num
                                            )
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "py-0 mr-3",
                                                    staticStyle: {
                                                      "max-width": "24px",
                                                    },
                                                    attrs: { cols: "6" },
                                                  },
                                                  [
                                                    _vm.fieldStatusIs(
                                                      "priceguarddataExpirationCycle",
                                                      _vm.getErrorEnums.LOADING
                                                    )
                                                      ? _c(
                                                          "v-progress-circular",
                                                          {
                                                            staticClass:
                                                              "saving-icon mt-1",
                                                            attrs: {
                                                              size: "16",
                                                              width: "2",
                                                              dense: "",
                                                              color: "primary",
                                                              indeterminate: "",
                                                            },
                                                          }
                                                        )
                                                      : _vm.fieldStatusIs(
                                                          "priceguarddataExpirationCycle",
                                                          _vm.getErrorEnums
                                                            .SAVED
                                                        )
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "saving-icon-green mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "fas fa-check "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.fieldStatusIs(
                                                          "priceguarddataExpirationCycle",
                                                          _vm.getErrorEnums
                                                            .DEFAULT
                                                        )
                                                      ? _c("div")
                                                      : _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "saving-icon-red mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "fas fa-times "
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "py-0 mr-1",
                                                    attrs: { cols: "4" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          justify: "start",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              "max-width":
                                                                "300",
                                                              bottom: "",
                                                              "content-class":
                                                                "text-center",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-icon",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "pt-1",
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            "far fa-question-circle "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ]
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Time in seconds (from when a price stopped matching the rule) after which it is considered expired. Default: 30sec "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { justify: "center", id: "text-fields" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "10",
                                    xl: "3",
                                    lg: "4",
                                    md: "4",
                                    sm: "5",
                                  },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass:
                                      "text-field rm-number-arrows settings-number-input",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      label: "Expired price removal:",
                                      id: "priceguardremoveExpiredDataAfter",
                                      type: "number",
                                      value:
                                        _vm.getFilteredSettings.applications
                                          .priceguard.removeExpiredDataAfter,
                                      height: "20",
                                      color: "primary",
                                      rules: [_vm.rules.num, _vm.rules.min],
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.ignoreInputChange
                                          ? ""
                                          : _vm.updateSetting(
                                              [
                                                "applications",
                                                "priceguard",
                                                "removeExpiredDataAfter",
                                              ],
                                              "priceguardremoveExpiredDataAfter",
                                              _vm.rules.num
                                            )
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "py-0 mr-3",
                                                    staticStyle: {
                                                      "max-width": "24px",
                                                    },
                                                    attrs: { cols: "6" },
                                                  },
                                                  [
                                                    _vm.fieldStatusIs(
                                                      "priceguardremoveExpiredDataAfter",
                                                      _vm.getErrorEnums.LOADING
                                                    )
                                                      ? _c(
                                                          "v-progress-circular",
                                                          {
                                                            staticClass:
                                                              "saving-icon mt-1",
                                                            attrs: {
                                                              size: "16",
                                                              width: "2",
                                                              dense: "",
                                                              color: "primary",
                                                              indeterminate: "",
                                                            },
                                                          }
                                                        )
                                                      : _vm.fieldStatusIs(
                                                          "priceguardremoveExpiredDataAfter",
                                                          _vm.getErrorEnums
                                                            .SAVED
                                                        )
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "saving-icon-green mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "fas fa-check "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.fieldStatusIs(
                                                          "priceguardremoveExpiredDataAfter",
                                                          _vm.getErrorEnums
                                                            .DEFAULT
                                                        )
                                                      ? _c("div")
                                                      : _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "saving-icon-red mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "fas fa-times "
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "py-0 mr-1",
                                                    attrs: { cols: "4" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          justify: "start",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              "max-width":
                                                                "300",
                                                              bottom: "",
                                                              "content-class":
                                                                "text-center",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-icon",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "pt-1",
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            "far fa-question-circle "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ]
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Time in seconds after which an expired price is removed "
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "(considering that expiring is ON). "
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "Default: 30sec "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _c("v-col", {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "10",
                                  xl: "3",
                                  lg: "4",
                                  md: "4",
                                  sm: "5",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h1",
                              {
                                staticClass: "titleClass",
                                class: _vm.darkTheme
                                  ? "title_dark"
                                  : "title_light",
                                staticStyle: { "padding-top": "50px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    attrs: { left: "" },
                                  },
                                  [_vm._v("icon-analytics-23x23 ")]
                                ),
                                _vm._v(" Analytics "),
                              ],
                              1
                            ),
                            _c(
                              "h2",
                              {
                                staticClass: "pt-5 mt-5 mb-5 secondary-h1",
                                class: _vm.darkTheme
                                  ? "lightText"
                                  : "darkText2",
                              },
                              [_vm._v(" Summary Table ")]
                            ),
                          ]),
                          _c(
                            "v-row",
                            {
                              staticClass: "my-2",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "settings-switch-row pt-2",
                                  staticStyle: {
                                    "border-top":
                                      "1px solid rgb(255, 255, 255, 0.2)",
                                  },
                                  attrs: { justify: "space-between" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "ml-4 mb-0",
                                      class: _vm.darkTheme
                                        ? "lightText"
                                        : "darkText2",
                                    },
                                    [_vm._v(" Use the actual currency digits ")]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticStyle: { "max-width": "88px" } },
                                    [
                                      _c("hr", { attrs: { width: "1" } }),
                                      _c("v-switch", {
                                        staticClass: "mt-0 pl-1 pt-0",
                                        staticStyle: { height: "30px" },
                                        attrs: { id: "useDigitsField" },
                                        model: {
                                          value: _vm.useDigitsField,
                                          callback: function ($$v) {
                                            _vm.useDigitsField = $$v
                                          },
                                          expression: "useDigitsField",
                                        },
                                      }),
                                      _vm.fieldStatusIs(
                                        "useDigitsField",
                                        _vm.getErrorEnums.LOADING
                                      )
                                        ? _c("v-progress-circular", {
                                            staticClass: "saving-icon mt-1",
                                            attrs: {
                                              size: "16",
                                              width: "2",
                                              dense: "",
                                              color: "primary",
                                              indeterminate: "",
                                            },
                                          })
                                        : _vm.fieldStatusIs(
                                            "useDigitsField",
                                            _vm.getErrorEnums.SAVED
                                          )
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-green",
                                            },
                                            [_vm._v("fas fa-check ")]
                                          )
                                        : _vm.fieldStatusIs(
                                            "useDigitsField",
                                            _vm.getErrorEnums.DEFAULT
                                          )
                                        ? _c("div", {
                                            staticStyle: { width: "16px" },
                                          })
                                        : _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-red",
                                              staticStyle: { height: "23px" },
                                            },
                                            [_vm._v("fas fa-times ")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isAdmin
                            ? _c("v-row", { attrs: { justify: "center" } }, [
                                _c(
                                  "h2",
                                  {
                                    staticClass: "pt-5 mt-5 mb-5 secondary-h1",
                                    class: _vm.darkTheme
                                      ? "lightText"
                                      : "darkText2",
                                  },
                                  [_vm._v(" Logs ")]
                                ),
                              ])
                            : _vm._e(),
                          _vm.isAdmin
                            ? _c(
                                "v-row",
                                {
                                  staticClass: "my-2",
                                  attrs: { justify: "center" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "settings-switch-row pt-2",
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgb(255, 255, 255, 0.2)",
                                      },
                                      attrs: { justify: "space-between" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "ml-4 mb-0",
                                          class: _vm.darkTheme
                                            ? "lightText"
                                            : "darkText2",
                                        },
                                        [_vm._v(" Log SSE data. ")]
                                      ),
                                      _c(
                                        "v-row",
                                        {
                                          staticStyle: { "max-width": "88px" },
                                        },
                                        [
                                          _c("hr", { attrs: { width: "1" } }),
                                          _c("v-switch", {
                                            staticClass: "mt-0 pl-1 pt-0",
                                            staticStyle: { height: "30px" },
                                            attrs: { id: "positionLogs" },
                                            model: {
                                              value: _vm.positionLogs,
                                              callback: function ($$v) {
                                                _vm.positionLogs = $$v
                                              },
                                              expression: "positionLogs",
                                            },
                                          }),
                                          _vm.fieldStatusIs(
                                            "positionLogs",
                                            _vm.getErrorEnums.LOADING
                                          )
                                            ? _c("v-progress-circular", {
                                                staticClass: "saving-icon mt-1",
                                                attrs: {
                                                  size: "16",
                                                  width: "2",
                                                  dense: "",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              })
                                            : _vm.fieldStatusIs(
                                                "positionLogs",
                                                _vm.getErrorEnums.SAVED
                                              )
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-green",
                                                },
                                                [_vm._v("fas fa-check ")]
                                              )
                                            : _vm.fieldStatusIs(
                                                "positionLogs",
                                                _vm.getErrorEnums.DEFAULT
                                              )
                                            ? _c("div", {
                                                staticStyle: { width: "16px" },
                                              })
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "saving-icon-red",
                                                  staticStyle: {
                                                    height: "23px",
                                                  },
                                                },
                                                [_vm._v("fas fa-times ")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h1",
                              {
                                staticClass: "titleClass",
                                class: _vm.darkTheme
                                  ? "title_dark"
                                  : "title_light",
                                staticStyle: { "padding-top": "50px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    attrs: { left: "" },
                                  },
                                  [_vm._v("fas fa-chart-line ")]
                                ),
                                _vm._v(" Price Watcher "),
                              ],
                              1
                            ),
                            _c(
                              "h2",
                              {
                                staticClass: "pt-5 mt-5 mb-5 secondary-h1",
                                class: _vm.darkTheme
                                  ? "lightText"
                                  : "darkText2",
                              },
                              [_vm._v(" Chart ")]
                            ),
                          ]),
                          _c(
                            "v-row",
                            {
                              staticClass: "pb-8 mb-8 my-2",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "settings-switch-row pt-2",
                                  staticStyle: {
                                    "border-top":
                                      "1px solid rgb(255, 255, 255, 0.2)",
                                  },
                                  attrs: {
                                    justify: "space-between",
                                    id: "keep-old-data",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "ml-4 mb-0",
                                      class: _vm.darkTheme
                                        ? "lightText"
                                        : "darkText2",
                                    },
                                    [_vm._v(" Keep previous time frame data ")]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticStyle: { "max-width": "88px" } },
                                    [
                                      _c("hr", { attrs: { width: "1" } }),
                                      _c("v-switch", {
                                        staticClass: "mt-0 pl-1 pt-0",
                                        staticStyle: { height: "30px" },
                                        attrs: {
                                          id: "keepPreviousTimeFrameData",
                                        },
                                        model: {
                                          value: _vm.keepPreviousTimeFrameData,
                                          callback: function ($$v) {
                                            _vm.keepPreviousTimeFrameData = $$v
                                          },
                                          expression:
                                            "keepPreviousTimeFrameData",
                                        },
                                      }),
                                      _vm.fieldStatusIs(
                                        "keepPreviousTimeFrameData",
                                        _vm.getErrorEnums.LOADING
                                      )
                                        ? _c("v-progress-circular", {
                                            staticClass: "saving-icon mt-1",
                                            attrs: {
                                              size: "16",
                                              width: "2",
                                              dense: "",
                                              color: "primary",
                                              indeterminate: "",
                                            },
                                          })
                                        : _vm.fieldStatusIs(
                                            "keepPreviousTimeFrameData",
                                            _vm.getErrorEnums.SAVED
                                          )
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-green",
                                            },
                                            [_vm._v("fas fa-check ")]
                                          )
                                        : _vm.fieldStatusIs(
                                            "keepPreviousTimeFrameData",
                                            _vm.getErrorEnums.DEFAULT
                                          )
                                        ? _c("div", {
                                            staticStyle: { width: "16px" },
                                          })
                                        : _c(
                                            "v-icon",
                                            {
                                              staticClass: "saving-icon-red",
                                              staticStyle: { height: "23px" },
                                            },
                                            [_vm._v("fas fa-times ")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "pb-8 mb-8 my-2",
                              attrs: {
                                id: "pw-warning-time",
                                justify: "center",
                              },
                            },
                            [
                              _c("v-text-field", {
                                staticClass:
                                  "rm-number-arrows settings-number-input",
                                staticStyle: { "max-width": "400px" },
                                attrs: {
                                  dense: "",
                                  id: "pricewatcherdataAbsenceWarning",
                                  type: "number",
                                  outlined: "",
                                  label: "Data absence warning (s)",
                                  value:
                                    _vm.getFilteredSettings.applications
                                      .pricewatcher.dataAbsenceWarning,
                                  height: "20",
                                  rules: [_vm.rules.num],
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.ignoreInputChange
                                      ? ""
                                      : _vm.updateSetting(
                                          [
                                            "applications",
                                            "pricewatcher",
                                            "dataAbsenceWarning",
                                          ],
                                          "dataAbsenceWarning",
                                          _vm.rules.num
                                        )
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "py-0 mr-3",
                                                staticStyle: {
                                                  "max-width": "24px",
                                                },
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _vm.fieldStatusIs(
                                                  "dataAbsenceWarning",
                                                  _vm.getErrorEnums.LOADING
                                                )
                                                  ? _c("v-progress-circular", {
                                                      staticClass:
                                                        "saving-icon mt-1",
                                                      attrs: {
                                                        size: "16",
                                                        width: "2",
                                                        dense: "",
                                                        color: "primary",
                                                        indeterminate: "",
                                                      },
                                                    })
                                                  : _vm.fieldStatusIs(
                                                      "dataAbsenceWarning",
                                                      _vm.getErrorEnums.SAVED
                                                    )
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "saving-icon-green mt-1",
                                                      },
                                                      [_vm._v("fas fa-check ")]
                                                    )
                                                  : _vm.fieldStatusIs(
                                                      "dataAbsenceWarning",
                                                      _vm.getErrorEnums.DEFAULT
                                                    )
                                                  ? _c("div")
                                                  : _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "saving-icon-red mt-1",
                                                      },
                                                      [_vm._v("fas fa-times ")]
                                                    ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "py-0 mr-1",
                                                attrs: { cols: "4" },
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    attrs: { justify: "start" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: {
                                                          "max-width": "300",
                                                          bottom: "",
                                                          "content-class":
                                                            "text-center",
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "pt-1",
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "far fa-question-circle "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ]),
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Time in seconds (from when a price matched the rule) after which it is considered old. Default: 30sec "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tooltip",
                            {
                              staticClass: "mt-3 ml-1",
                              attrs: {
                                activator: "#pw-warning-time",
                                disabled: _vm.isNotDesktop,
                                "content-class": "tooltipClassBottom",
                                "nudge-top": "10",
                                bottom: "",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " A warning icon is shown on the chart if no update "
                                ),
                                _c("br"),
                                _vm._v(
                                  " was received after a specified amount of time (in seconds) "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        { staticClass: "darkText" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "row1",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "h1",
                                {
                                  staticClass: "titleClass",
                                  class: _vm.darkTheme
                                    ? "title_dark"
                                    : "title_light",
                                  staticStyle: { "padding-top": "30px" },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      class: _vm.darkTheme
                                        ? "title_dark"
                                        : "title_light",
                                      staticStyle: { "font-size": "21px" },
                                      attrs: { left: "" },
                                    },
                                    [_vm._v("fas fa-lock ")]
                                  ),
                                  _vm._v(" Login & Password "),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "justify-center pt-10" },
                                [
                                  _vm.showChangePass === false
                                    ? [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { color: "primary" },
                                            on: {
                                              click: function ($event) {
                                                _vm.showChangePass = true
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { left: "" } },
                                              [_vm._v(" fa fa-key ")]
                                            ),
                                            _vm._v(" Change Password "),
                                          ],
                                          1
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "v-form",
                                          { ref: "changePassForm" },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "mx-2",
                                                attrs: { justify: "center" },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "py-0",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        id: "oldPasswordInput",
                                                        dense: "",
                                                        outlined: "",
                                                        label:
                                                          "Current Password",
                                                        type: _vm.changePassword
                                                          .showOldPass
                                                          ? "text"
                                                          : "password",
                                                        "append-icon": _vm
                                                          .changePassword
                                                          .showOldPass
                                                          ? "fas fa-eye-slash"
                                                          : "fas fa-eye",
                                                        rules: [
                                                          _vm.rules.required,
                                                        ],
                                                        disabled:
                                                          _vm.savingNewPass,
                                                      },
                                                      on: {
                                                        "click:append":
                                                          function ($event) {
                                                            _vm.changePassword.showOldPass =
                                                              !_vm
                                                                .changePassword
                                                                .showOldPass
                                                          },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.changePassword
                                                            .oldPassword,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.changePassword,
                                                            "oldPassword",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "changePassword.oldPassword",
                                                      },
                                                    }),
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        id: "newPasswordInput",
                                                        dense: "",
                                                        outlined: "",
                                                        label: "New Password",
                                                        type: _vm.changePassword
                                                          .showNewPass
                                                          ? "text"
                                                          : "password",
                                                        "append-icon": _vm
                                                          .changePassword
                                                          .showNewPass
                                                          ? "fas fa-eye-slash"
                                                          : "fas fa-eye",
                                                        rules: [
                                                          _vm.rules.required,
                                                        ],
                                                        disabled:
                                                          _vm.savingNewPass,
                                                      },
                                                      on: {
                                                        "click:append":
                                                          function ($event) {
                                                            _vm.changePassword.showNewPass =
                                                              !_vm
                                                                .changePassword
                                                                .showNewPass
                                                          },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.changePassword
                                                            .newPassword,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.changePassword,
                                                            "newPassword",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "changePassword.newPassword",
                                                      },
                                                    }),
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        id: "verifyPasswordInput",
                                                        dense: "",
                                                        outlined: "",
                                                        label:
                                                          "Verify Password",
                                                        hint: "type your new password again",
                                                        type: "password",
                                                        rules: [
                                                          _vm.rules.required,
                                                          _vm.rules.newPasswordMatch(
                                                            _vm.changePassword
                                                              .confirmNewPassword,
                                                            _vm.changePassword
                                                              .newPassword
                                                          ),
                                                        ],
                                                        disabled:
                                                          _vm.savingNewPass,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.changePassword
                                                            .confirmNewPassword,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.changePassword,
                                                            "confirmNewPassword",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "changePassword.confirmNewPassword",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "px-8",
                                                attrs: { justify: "end" },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.savingNewPass,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.cancelChangePassword,
                                                    },
                                                  },
                                                  [_vm._v(" Cancel ")]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      color: "primary",
                                                      disabled:
                                                        _vm.savingNewPass,
                                                      loading:
                                                        _vm.savingNewPass,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.$refs.changePassForm.validate()
                                                          ? _vm.saveNewPassword()
                                                          : false
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Save ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]
                          ),
                          _c("v-row", { attrs: { justify: "center" } }, [
                            _c(
                              "h1",
                              {
                                staticClass: "titleClass",
                                class: _vm.darkTheme
                                  ? "title_dark"
                                  : "title_light",
                                staticStyle: { "padding-top": "50px" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    class: _vm.darkTheme
                                      ? "title_dark"
                                      : "title_light",
                                    staticStyle: { "font-size": "21px" },
                                    attrs: { left: "" },
                                  },
                                  [_vm._v("fas fa-users-cog ")]
                                ),
                                _vm._v(" Users "),
                              ],
                              1
                            ),
                          ]),
                          _vm.isAdmin
                            ? _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _vm.loadingUsers
                                    ? _c("v-progress-circular", {
                                        attrs: {
                                          size: 20,
                                          width: "2",
                                          color: "primary",
                                          indeterminate: "",
                                        },
                                      })
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "5",
                                        lg: "9",
                                        md: "8",
                                        sm: "10",
                                        cols: "11",
                                      },
                                    },
                                    [
                                      _c("v-data-table", {
                                        staticClass:
                                          "mt-10 accent stickyHeader",
                                        staticStyle: {
                                          "z-index": "999 !important",
                                          "border-radius": "4px",
                                          border:
                                            "1px solid #47bd96 !important",
                                        },
                                        attrs: {
                                          "mobile-breakpoint": 0,
                                          dense: "",
                                          "hide-default-footer": "",
                                          "fixed-header": "",
                                          "no-data-text": _vm.loadingUsersError
                                            ? `Couldn't fetch users`
                                            : "No users",
                                          height: 210,
                                          items: _vm.users,
                                          headers: _vm.usersHeaders,
                                          expanded: _vm.expanded,
                                          "hide-default-header": "",
                                          "items-per-page": -1,
                                        },
                                        on: {
                                          "update:expanded": function ($event) {
                                            _vm.expanded = $event
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item",
                                              fn: function ({ item }) {
                                                return [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "table_Row rowClick",
                                                      attrs: {
                                                        id: _vm.$vuetify.theme
                                                          .dark
                                                          ? "dataTableRow_dark"
                                                          : "dataTableRow_light",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.expandRow(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.headersCounter !==
                                                          _vm.usersHeaders
                                                            .length
                                                          ? _vm.headersCounter
                                                          : _vm.headersCounter -
                                                              1,
                                                        function (header, i) {
                                                          return _c(
                                                            "td",
                                                            { key: i },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  attrs: {
                                                                    justify:
                                                                      _vm
                                                                        .usersHeaders[
                                                                        i
                                                                      ]
                                                                        .value ===
                                                                      "enabled"
                                                                        ? "center"
                                                                        : "start",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.headersCounter ===
                                                                  1
                                                                    ? _c("p", {
                                                                        style: `margin-left: 30% !important;`,
                                                                      })
                                                                    : _vm._e(),
                                                                  _vm
                                                                    .usersHeaders[
                                                                    i
                                                                  ].value ===
                                                                    "username" &&
                                                                  _vm.headersCounter !==
                                                                    _vm
                                                                      .usersHeaders
                                                                      .length
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          class:
                                                                            _vm.expanded.some(
                                                                              (
                                                                                el
                                                                              ) =>
                                                                                el.id ===
                                                                                item.id
                                                                            )
                                                                              ? "red--text pr-1 ml-3"
                                                                              : "primary--text pr-1 ml-3",
                                                                          staticStyle:
                                                                            {
                                                                              "font-size":
                                                                                "16px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.expanded.some(
                                                                                  (
                                                                                    el
                                                                                  ) =>
                                                                                    el.id ===
                                                                                    item.id
                                                                                )
                                                                                  ? "fas fa-times-circle"
                                                                                  : "fas fa-chevron-circle-down"
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm
                                                                    .usersHeaders[
                                                                    i
                                                                  ].value !==
                                                                    "enabled" &&
                                                                  _vm
                                                                    .usersHeaders[
                                                                    i
                                                                  ].value !==
                                                                    "roles"
                                                                    ? _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "email-char-lim my-auto",
                                                                          class:
                                                                            _vm.headersCounter <
                                                                              _vm
                                                                                .usersHeaders
                                                                                .length &&
                                                                            _vm
                                                                              .usersHeaders[
                                                                              i
                                                                            ]
                                                                              .value ===
                                                                              "username"
                                                                              ? "ml-1"
                                                                              : "ml-3",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                item[
                                                                                  _vm
                                                                                    .usersHeaders[
                                                                                    i
                                                                                  ]
                                                                                    .value
                                                                                ]
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm
                                                                        .usersHeaders[
                                                                        i
                                                                      ]
                                                                        .value ===
                                                                      "roles"
                                                                    ? _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "my-auto",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getUserRolesText(
                                                                                  item.roles
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : item.enabled
                                                                    ? _c(
                                                                        "v-switch",
                                                                        {
                                                                          staticClass:
                                                                            "mt-0",
                                                                          staticStyle:
                                                                            {
                                                                              height:
                                                                                "36px",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "primary",
                                                                              value:
                                                                                "",
                                                                              "input-value":
                                                                                "true",
                                                                              disabled:
                                                                                "",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _c(
                                                                        "v-switch",
                                                                        {
                                                                          staticClass:
                                                                            "mt-0",
                                                                          staticStyle:
                                                                            {
                                                                              height:
                                                                                "36px",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "primary",
                                                                              value:
                                                                                "",
                                                                              "input-value": false,
                                                                              disabled:
                                                                                "",
                                                                            },
                                                                        }
                                                                      ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      _vm.headersCounter ===
                                                      _vm.usersHeaders.length
                                                        ? _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showEditDialog(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "icon-edit-21x21",
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "28px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "path1 letterSpacing0",
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "path2",
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showDeleteDialog(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "icon-delete-21x21",
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "28px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "path1 letterSpacing0",
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "path2",
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "expanded-item",
                                              fn: function ({ item }) {
                                                return _vm._l(
                                                  _vm.usersHeaders.length -
                                                    _vm.headersCounter,
                                                  function (
                                                    headerIndex,
                                                    index
                                                  ) {
                                                    return _c(
                                                      "tr",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "expandBackground",
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticClass:
                                                              "expandRowClass_Border mx-0",
                                                            staticStyle: {
                                                              height: "32px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "py-0",
                                                                attrs: {
                                                                  cols: "3",
                                                                },
                                                              },
                                                              [
                                                                item || !item
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1 my-1",
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "600",
                                                                            "font-size":
                                                                              "14px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .usersHeaders[
                                                                                index +
                                                                                  _vm.headersCounter
                                                                              ]
                                                                                .text
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "py-0",
                                                                attrs: {
                                                                  cols: "8",
                                                                },
                                                              },
                                                              [
                                                                headerIndex <
                                                                _vm.usersHeaders
                                                                  .length -
                                                                  _vm.headersCounter
                                                                  ? _c(
                                                                      "div",
                                                                      [
                                                                        _vm
                                                                          .usersHeaders[
                                                                          index +
                                                                            _vm.headersCounter
                                                                        ]
                                                                          .value !==
                                                                          "enabled" &&
                                                                        _vm
                                                                          .usersHeaders[
                                                                          index +
                                                                            _vm.headersCounter
                                                                        ]
                                                                          .value !==
                                                                          "roles"
                                                                          ? _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "ml-1 my-1 pt-1 text-center char-lim",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "14px",
                                                                                    margin:
                                                                                      "auto !important",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      item[
                                                                                        _vm
                                                                                          .usersHeaders[
                                                                                          index +
                                                                                            _vm.headersCounter
                                                                                        ]
                                                                                          .value
                                                                                      ]
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm
                                                                              .usersHeaders[
                                                                              index +
                                                                                _vm.headersCounter
                                                                            ]
                                                                              .value ===
                                                                            "roles"
                                                                          ? _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "ml-1 my-1 pt-1 text-center char-lim",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "14px",
                                                                                    margin:
                                                                                      "auto !important",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      _vm.getUserRolesText(
                                                                                        item[
                                                                                          _vm
                                                                                            .usersHeaders[
                                                                                            index +
                                                                                              _vm.headersCounter
                                                                                          ]
                                                                                            .value
                                                                                        ]
                                                                                      )
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : item.enabled
                                                                          ? _c(
                                                                              "v-switch",
                                                                              {
                                                                                staticClass:
                                                                                  "mt-0 mx-auto",
                                                                                staticStyle:
                                                                                  {
                                                                                    height:
                                                                                      "36px",
                                                                                    width:
                                                                                      "45px !important",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "primary",
                                                                                    value:
                                                                                      "",
                                                                                    "input-value":
                                                                                      "true",
                                                                                    disabled:
                                                                                      "",
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "v-switch",
                                                                              {
                                                                                staticClass:
                                                                                  "mt-0 mx-auto",
                                                                                staticStyle:
                                                                                  {
                                                                                    height:
                                                                                      "36px",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "primary",
                                                                                    value:
                                                                                      "",
                                                                                    "input-value":
                                                                                      "false",
                                                                                    disabledf:
                                                                                      "",
                                                                                  },
                                                                              }
                                                                            ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "text-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                height:
                                                                                  "32",
                                                                                icon: "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.showDeleteDialog(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "icon-delete-21x21",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "28px",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "path1 letterSpacing0",
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "path2",
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._l(
                                                          _vm.headersCounter -
                                                            1,
                                                          function (header) {
                                                            return _c("td", {
                                                              key: header,
                                                              staticStyle: {
                                                                border: "none",
                                                              },
                                                            })
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                )
                                              },
                                            },
                                            {
                                              key: "header",
                                              fn: function ({
                                                props: { headers },
                                              }) {
                                                return [
                                                  _c("thead", [
                                                    _c(
                                                      "tr",
                                                      _vm._l(
                                                        headers.filter(
                                                          (el, index) => {
                                                            return (
                                                              index + 1 <=
                                                              _vm.headersCounter
                                                            )
                                                          }
                                                        ),
                                                        function (header) {
                                                          return _c(
                                                            "th",
                                                            {
                                                              key: header.value,
                                                              staticStyle: {
                                                                background:
                                                                  "#47bd96",
                                                                color: "white",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "py-0",
                                                                      attrs: {
                                                                        height:
                                                                          "100%",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-row",
                                                                        {
                                                                          class:
                                                                            header.value ===
                                                                              "actions" ||
                                                                            header.value ===
                                                                              "enabled"
                                                                              ? "pl-0"
                                                                              : "pl-3",
                                                                          style:
                                                                            header.value ===
                                                                              "actions" ||
                                                                            header.value ===
                                                                              "enabled" ||
                                                                            _vm.headersCounter ===
                                                                              1
                                                                              ? "justify-content: center;"
                                                                              : "",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "my-0 fullHeight allTableHeadersHover",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    header.text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          433137145
                                        ),
                                      }),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "px-1 mt-2",
                                          attrs: {
                                            outlined: "",
                                            color: "primary",
                                            small: "",
                                          },
                                          on: { click: _vm.showAddDialog },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [_vm._v("fas fa-plus-circle ")]
                                          ),
                                          _vm._v(" Add user "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-row",
                            {
                              staticClass: "pt-10",
                              attrs: { justify: "center" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "settings-switch-row pt-2",
                                  staticStyle: {
                                    "border-top":
                                      "1px solid rgb(255, 255, 255, 0.2)",
                                  },
                                  attrs: { justify: "space-between" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "ml-4 mb-0",
                                      class: _vm.darkTheme
                                        ? "lightText"
                                        : "darkText2",
                                    },
                                    [
                                      _vm._v(
                                        " User Profile: " +
                                          _vm._s(
                                            _vm.selectedProfile.configuration
                                              .device
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.isAdmin &&
                                              _vm.selectedProfile.username
                                              ? ` (${_vm.selectedProfile.username})`
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticStyle: { "max-width": "88px" } },
                                    [
                                      _c("hr", { attrs: { width: "1" } }),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ml-3",
                                          staticStyle: {
                                            "padding-bottom": "6px",
                                          },
                                          attrs: { small: "", icon: "" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.changeProfile.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "icon-edit-21x21",
                                              staticStyle: {
                                                "font-size": "27px",
                                                "margin-bottom": "2px",
                                              },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "path1 letterSpacing0",
                                              }),
                                              _c("span", {
                                                staticClass: "path2",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        { staticClass: "darkText" },
                        [
                          _c(
                            "v-row",
                            { attrs: { justify: "center" } },
                            [
                              _c("notification-settings", {
                                on: { refresh: _vm.prepareData },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        { staticClass: "darkText" },
                        [
                          _c(
                            "v-row",
                            { attrs: { justify: "center" } },
                            [_c("tenants")],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
      _c(
        "v-snackbar",
        {
          class: !!_vm.changePassword.updateSuccess
            ? "snackbar-panel success-color"
            : "snackbar-panel error-color",
          attrs: {
            timeout: "4000",
            outlined: "",
            bottom: "",
            left: "",
            color: !!_vm.changePassword.updateSuccess
              ? "success"
              : "red accent-2",
          },
          model: {
            value: _vm.changePassword.showSnackbar,
            callback: function ($$v) {
              _vm.$set(_vm.changePassword, "showSnackbar", $$v)
            },
            expression: "changePassword.showSnackbar",
          },
        },
        [
          _c(
            "v-row",
            {
              on: {
                click: function ($event) {
                  _vm.changePassword.showSnackbar = false
                },
              },
            },
            [
              _c(
                "v-col",
                { staticClass: "pa-0 text-center", attrs: { cols: "2" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "flex align-center",
                      class: !!_vm.changePassword.updateSuccess
                        ? "success-color"
                        : "error-color",
                      attrs: { size: "1.4em" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            !!_vm.changePassword.updateSuccess
                              ? "far fa-check-circle"
                              : "fas fa-exclamation-circle"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-col", { staticClass: "pa-0", attrs: { cols: "10" } }, [
                _c(
                  "div",
                  {
                    staticClass: "flex align-center",
                    class: !!_vm.changePassword.updateSuccess
                      ? "success-color"
                      : "error-color",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          !!_vm.changePassword.updateSuccess > 0
                            ? "Password successfully changed"
                            : "Error changing password"
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }